import { useMemo } from "react";

const hashSeed = (s) => {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
};

export const Waveform = ({ seed = "beat", progress = 0, onSeek, bars = 56, height = 44, live = false }) => {
  const heights = useMemo(() => {
    const h = hashSeed(String(seed));
    return Array.from({ length: bars }, (_, i) => {
      const v = Math.sin((i + 1) * (h % 13) * 0.7) * 0.5 + Math.sin((i + 3) * (h % 7) * 1.3) * 0.5;
      return 22 + Math.abs(v) * 72;
    });
  }, [seed, bars]);

  const handleClick = (e) => {
    if (!onSeek) return;
    const rect = e.currentTarget.getBoundingClientRect();
    onSeek(Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)));
  };

  return (
    <div
      data-testid={`waveform-${seed}`}
      className={`flex w-full items-end gap-[2px] ${onSeek ? "cursor-pointer" : ""}`}
      style={{ height }}
      onClick={handleClick}
    >
      {heights.map((h, i) => {
        const filled = i / bars <= progress;
        return (
          <div
            key={i}
            className={`flex-1 rounded-full transition-colors duration-150 ${
              filled ? "bg-emerald-300" : "bg-zinc-700/70"
            } ${live && filled ? "eq-live" : ""}`}
            style={{ height: `${h}%`, animationDelay: `${(i % 8) * 0.08}s` }}
          />
        );
      })}
    </div>
  );
};
